import { render } from "./UnitAssignment.vue?vue&type=template&id=345d697d&scoped=true"
import script from "./UnitAssignment.vue?vue&type=script&lang=js"
export * from "./UnitAssignment.vue?vue&type=script&lang=js"

import "./UnitAssignment.vue?vue&type=style&index=0&id=345d697d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345d697d"]])

export default __exports__